import { render, staticRenderFns } from "./workShopManageNew.vue?vue&type=template&id=c3801d74&scoped=true&"
import script from "./workShopManageNew.vue?vue&type=script&lang=js&"
export * from "./workShopManageNew.vue?vue&type=script&lang=js&"
import style0 from "./workShopManageNew.vue?vue&type=style&index=0&id=c3801d74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3801d74",
  null
  
)

export default component.exports